import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import Button from 'react-bootstrap/Button';
import axios from 'axios';
import { useAuth } from '../../utils/auth';
import { useNavigate } from 'react-router-dom';
import '../../styles/common.css';
import '../../styles/board/board.css';
import Spinner from 'react-bootstrap/Spinner';

const Board = () => {
  const [boardList, setBoardList] = useState([]);
  const { authInfo } = useAuth();
  const navigate = useNavigate();
  const [loading,setLoading] = useState(true);

  useEffect(() => {
    const fetchBoardList = async () => {
      try {
        const response = await axios.get('/board');
        console.log('board list:', response.data);
        setBoardList(response.data);
      } catch (error) {
        console.error('Error fetching board list:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBoardList();
  }, []);

  if (loading) {
    return (
      <div className="loading-container" style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '50vh', 
          flexDirection: 'column' 
      }}>
        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
        <h4 style={{ marginTop: '20px' }}>게시글을 불러오고 있습니다...</h4>
      </div>
    );
  }

  const boardCreate = () => {
    if (authInfo.token) {
      console.log('글쓰기버튼활성화');
      navigate('/boardCreate');
    } else {
      alert('로그인 후 이용하세요.');
    }
  };

  const redirectToDetail = (boardId) => {
    if(authInfo.token){
      navigate(`/boardDetail/${boardId}`);
    }else{
      alert('회원만 이용이 가능합니다. 가입후 이용해주세요');
    }
  };

  const formatDate = (dateArray) => {
    if (!Array.isArray(dateArray) || dateArray.length < 6) return "날짜 없음";
  
    const [year, month, day, hour, minute] = dateArray;
  
    // `Date` 객체 생성 (월은 0부터 시작하므로 `month - 1`)
    const dateObj = new Date(year, month - 1, day, hour, minute);
  
    if (isNaN(dateObj.getTime())) {
      return "올바르지 않은 날짜";
    }
  
    // 날짜 포맷 적용
    const formattedDate = dateObj.toLocaleString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true, // AM/PM 표시
    });
  
    // "MM/DD/YYYY, hh:mm AM" 형식 → "YYYY/MM/DD hh:mmAM"으로 변환
    const [monthPart, dayPart, yearPart] = formattedDate.split(",")[0].split("/");
    const timePart = formattedDate.split(", ")[1];
  
    return `${yearPart}/${monthPart}/${dayPart} ${timePart}`;
  };
  
  

  return (
    <div className='common-container'>
      <Button variant="outline-success" onClick={boardCreate} id='board-insert-btn'>
        글쓰기
      </Button>{' '}
      <div className='board-list-div'>
      <Table striped="columns" className="board-tb">
        <thead>
          <tr>
            <th style={{width:'100px'}}>게시글번호</th>
            <th>제목</th>
            <th>작성일</th>
            <th>작성자</th>
          </tr>
        </thead>
        <tbody>
          {boardList.map((board,index) => (
            <tr key={board.boardId} >
              <td>{boardList.length - index}</td>
              <td className="title-cell" onClick={() => redirectToDetail(board.boardId)}>{board.title}</td>
              <td>{formatDate(board.regdate)}</td>
              <td>{board.nickname}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      </div>
    </div>
  );
};

export default Board;
